import React from "react";
import Aux from "../utils/AuxFunctions";
import "./Account.css"
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Colors from "../utils/Colors";
import { withRouter } from "react-router-dom";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import axios from "axios";
import LoadingHelper from "../utils/Utilities/LoadingHelper";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";
class ChangeReferUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            referral: {},
            code: "",
            codeError: "",
            loading: false,
            noReferral: false,
        }
    }

    componentDidMount() {
        try {
            if (this.props.myDataProvider.user) {
                if (this.props.myDataProvider.user.referralUser) {
                    this.getUserInfo()
                }
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.myDataProvider.user !== prevProps.myDataProvider.user) {
            //this.setState({ user: this.props.myDataProvider.user })
            if (this.props.myDataProvider.user) {
                if (this.props.myDataProvider.user.referralUser) {
                    this.getUserInfo()
                }
            }


        }
    }

    getUserInfo = async () => {
        if (!this.props.myDataProvider.user.referralUser) {
            return
        }
        try {
            let userQuery = await Fire.shared.firestore.collection("users").doc(this.props.myDataProvider.user.referralUser).get();
            if (userQuery.exists) {
                this.setState({ referral: userQuery.data() })
            } else {
                this.setState({ noReferral: true })
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToProfile = (profile) => {
        try {
            this.props.history.push("/user/" + profile)
        } catch (error) {
            Aux.handleError(error)
        }
    }

    onSubmitReferral = async () => {
        if (this.state.loading)
            return;
        if (this.state.code === "") {
            this.setState({ codeError: "Insert a valid username" })
            return;
        }
        if (this.props.myDataProvider.user.referralUser) {
            this.setState({ codeError: "You already used a referral" })
            return;
        }
        if (this.state.code === this.props.myDataProvider.user.username) {
            this.setState({ codeError: "Can't use your own username" })
            return;
        }
        try {
            this.setState({ loading: true })
            const status = await Fire.shared.submitReferralLinkUsername(this.state.code)
            if (status === 2) {
                this.setState({ codeError: "Username is invalid, try another" })
            } else if (status === 4) {
                this.setState({ codeError: "You already have a referral user" })
            } else if (status !== "") {
                this.getUserInfo(status)
                //this.props.myDataProvider.updateUser(Fire.shared.user);

                this.setState(prevState => ({
                    user: {                   // object that we want to update
                        ...prevState.user,
                        referralUser: status,
                        sucess: true,
                    }
                }))
            }

        } catch (error) {
            Aux.handleError(error)
        }
        this.setState({ loading: false })
    }

    checkIfCode = async () => {
        if (!this.state.promoCode) {
            return;
        }
        try {
            this.setState({ loadingCodeValue: true })
            const result = await axios.post(process.env.REACT_APP_API_URL_CODE, { code: this.state.promoCode })
            if (result.status === 200) {
                if (result.data) {
                    this.setState({ loadingCodeValue: false, validPromoCode: result.data.code, validPromoReward: result.data.reward })
                } else {
                    this.setState({ loadingCodeValue: false, promoError: "The code is invalid" })
                }

            } else {
                this.setState({ loadingCodeValue: false, promoError: "An unexpected error has occurred" })
                return
            }
        } catch (error) {
            Aux.handleError(error)
            this.setState({ loadingCodeValue: false, promoError: "An unexpected error has occurred" })
        }
    }

    addCode = async () => {
        if (!this.state.validPromoCode) {
            return
        }
        try {
            this.setState({ loadingPromo: true })
            const result = await Fire.shared.addPromoCode(this.state.validPromoCode, this.state.validPromoReward)
            if (result === 2) {
                this.setState({ promoError: "You already used that code" })
            } else {
                this.setState({ successCode: true })
            }
            this.setState({ loadingPromo: false })
        } catch (error) {
            Aux.handleError(error)
            this.setState({ loadingPromo: false, promoError: "An unexpected error has occurred" })
        }
    }

    goBack = () => {
        try {
            this.props.history.goBack()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    render() {

        return (
            <div style={{ width: "100%" }}>
                <section className="container">
                    {/* <img alt="logo" src={Aux.LogoImage} style={{ width: 50, objectFit: "contain" }}></img> */}
                    <div className="reversed-button-hover" style={{ display: "flex", alignItems: "center", }} onClick={this.goBack}>
                        <ChevronLeftIcon style={{ marginRight: 5 }}></ChevronLeftIcon>
                        <h2>Referrals {"&"} Promo Codes</h2>
                    </div>
                    <div style={{ marginTop: 20, marginLeft: 20 }}>
                        
                        {this.props.myDataProvider.user ?
                        
                            <div>
                                <span style={{color:Colors.darkText, fontWeight:"bold"}}>Referral</span>
                                {this.props.myDataProvider.user.referralUser ?
                                    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", marginTop: 30, marginBottom: 5, marginLeft:20, marginRight:20}}>

                                        {this.state.referral.username ?
                                            (<span style={{ color: "black", fontSize: 20, textAlign: "center" }} onClick={this.goToProfile}>
                                                you already used <b style={{ cursor: "pointer" }}>{this.state.referral.username}</b> referral!
                                            </span>)
                                            :
                                            (<span style={{ color: "black", fontSize: 20, textAlign: "center" }}>
                                                you already used a referral!
                                            </span>)
                                        }
                                        <span style={{ color: "#ccc", fontSize: 14, marginTop: 10, textAlign: "center" }}>
                                            You've already told us who recommended you.
                                    </span>
                                    </div>
                                    :
                                    <div style={{ margin:"10px 20px" }}>
                                        <span style={{ color: "#777", fontSize:14 }}> Tell us who recommended you and both get <span style={{ color: Colors.green, fontWeight: "bold" }}>+10$</span>!</span>
                                        <ErrorMessage text={this.state.codeError}></ErrorMessage>
                                           {/*  <span>Username</span> */}
                                            <TextInputMaterial  type="text" title="Refer" 
                                                placeholder="Username of your friend" style={{marginTop:15}}
                                                onChange={(e) => {
                                                    this.setState({ code: e.target.value, codeError: "" });
                                                }}
                                            />
                                        <ButtonLoader
                                            text="Confirm Username"
                                            loading={this.state.loading}
                                            style={{ backgroundColor: Colors.mainColor, width: "100%", height:45, marginTop:20 }}
                                            // icon={FacebookIcon}
                                            onClick={this.onSubmitReferral}
                                        ></ButtonLoader>

                                    </div>
                                }
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ marginTop: 30, }}>
                                        <span style={{color:Colors.darkText, fontWeight:"bold"}}>Promo Code</span>
                                    </div>
                                    <ErrorMessage text={this.state.promoError}></ErrorMessage>
                                    <SucessMessage isSucess={this.state.successCode} text="Code successfully redeemed"></SucessMessage>
                                    {!this.state.validPromoCode ?
                                        <div style={{ margin: "20px 20px", display: "flex", justifyContent: "center", flexDirection: "column" }}>
                                            <span style={{ color: "#777", fontSize:14 }}>Enter a valid promo code and get a reward.</span>
                                            
                                            <TextInputMaterial type="text" title="Code" placeholder="Insert your promo code here"
                                                style={{marginTop:15}}
                                                onChange={(e) => {
                                                    this.setState({ promoCode: e.target.value, promoError: "" });
                                                }}
                                            />
                                            <ButtonLoader
                                                text="Check Code"
                                                loading={this.state.loadingCodeValue}
                                                style={{ backgroundColor: Colors.mainColor, width:"100%", height:45, marginTop:20 }}
                                                // icon={FacebookIcon}
                                                onClick={this.checkIfCode}
                                            />
                                        </div> :
                                        <div style={{ margin: "20px 20px", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                                            <div style={{ marginBottom: 20, }}>
                                                <span>Do you want to add the code: {this.state.validPromoCode} and get {this.state.validPromoReward}$ reward? </span>
                                            </div>
                                            <ButtonLoader
                                                text="Add Code"
                                                loading={this.state.loadingPromo}
                                                style={{ backgroundColor: Colors.mainColor, width: 200, alignSelf:"center" }}
                                                isFinished={this.state.successCode}
                                                // icon={FacebookIcon}
                                                onClick={this.addCode}
                                            />
                                        </div>}

                                </div>
                            </div> :
                            <LoadingHelper/>
                        }


                    </div>
                </section>
            </div>
        );
    }
}

export default withMyDataContext(withRouter(ChangeReferUser));